import { render, staticRenderFns } from "./Mbti.vue?vue&type=template&id=04292a64&scoped=true&"
import script from "./Mbti.vue?vue&type=script&lang=js&"
export * from "./Mbti.vue?vue&type=script&lang=js&"
import style0 from "./Mbti.vue?vue&type=style&index=0&id=04292a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04292a64",
  null
  
)

export default component.exports